module.exports = __webpack_public_path__ + "static/logo_black-65bd8c44a41ce8795e6bed98d5019112.png";